<template>
	<div class="biyezheng-page">
		<div class="goback" @click="$router.go(-1)">返回</div>
		<img :src="imgUrl" class="head-img">
		<div class="ewm-box">
			<!-- <img src="../images/WechatIMG59.png" class="wechat"> -->
			<QRCodeCanvas :msg="imgUrl"></QRCodeCanvas>
		</div>
	</div>
</template>
<script>
	import QRCodeCanvas from './qrCode.vue'
export default {
  name: 'biyezheng',
  data () {
    return {
    	imgUrl:''
    }
  },
  components: {
	  QRCodeCanvas
	},
  mounted(){
    var imgUrl = this.$route.query.imgUrl;
    this.imgUrl = gloabFile + 'file/download?path='+imgUrl;
  },

  methods:{

  }
}
</script>
<style>
	.biyezheng-page{
		position: relative;
	}
	.head-img{
		position: absolute;
		width:100%;
		height: 100vh;
		margin-bottom: -15px;
		overflow: hidden;
	}
	.date-box{
		position: absolute;
    top: 8.36rem;
    left: 34%;
    font-size: .25rem;
    color: #64605a;
	}
	.ewm-box{
		width:3.6rem;
		height: 5rem;
		position: relative;
	    /*top: 50%;*/
	    left: 56%;
	}
</style>


// WEBPACK FOOTER //
// src/components/biyezheng.vue